/* One absolute, Paris-qualified edition deadline; never a per-visitor reset. */
(function () {
  'use strict';
  if (window.__rbSeasonal2026Refresh) { window.__rbSeasonal2026Refresh(); return; }
  var timeout;
  function refresh() {
    window.clearTimeout(timeout);
    var now = Date.now(), next = 60000, active = false;
    document.querySelectorAll('[data-rb-seasonal]').forEach(function (node) {
      var end = Date.parse(node.getAttribute('data-rb-seasonal-deadline'));
      var delta = end - now;
      var top = node.getAttribute('data-rb-seasonal-placement') === 'top';
      var wrapper = top ? node.closest('.shopify-section') : null;
      if (!Number.isFinite(delta) || delta <= 0) {
        node.hidden = true;
        if (wrapper) wrapper.hidden = true;
        return;
      }
      node.hidden = false;
      if (wrapper) wrapper.hidden = false;
      active = true;
      next = Math.min(next, delta, (delta % 60000 || 60000) + 25);
      var total = Math.ceil(delta / 60000);
      var parts = {days:Math.floor(total / 1440),hours:Math.floor(total % 1440 / 60),minutes:total % 60};
      Object.keys(parts).forEach(function (unit) {
        var field = node.querySelector('[data-rb-' + unit + ']');
        if (field) field.textContent = unit === 'days' ? String(parts[unit]) : String(parts[unit]).padStart(2,'0');
      });
      var timer = node.querySelector('[data-rb-seasonal-timer]');
      if (timer) timer.setAttribute('aria-label', parts.days+' jours, '+parts.hours+' heures, '+parts.minutes+' minutes avant la fin de cette édition commerciale, heure de Paris.');
    });
    if (active) timeout = window.setTimeout(refresh, Math.max(1,next));
  }
  window.__rbSeasonal2026Refresh = refresh;
  document.addEventListener('visibilitychange',refresh);
  document.addEventListener('shopify:section:load',refresh);
  refresh();
})();

/* One delegated control pauses both the marquee and the reassurance pulse. */
(function () {
  'use strict';
  if (window.__rbImpactMotionBound) return;
  window.__rbImpactMotionBound = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rb-motion-toggle]');
    if (!button) return;
    var paused = !document.documentElement.hasAttribute('data-rb-motion-paused');
    document.documentElement.toggleAttribute('data-rb-motion-paused', paused);
    document.querySelectorAll('[data-rb-motion-toggle]').forEach(function (control) {
      var label = paused ? 'Reprendre les animations' : 'Mettre les animations en pause';
      control.setAttribute('aria-pressed', String(paused));
      control.setAttribute('aria-label', label);
      control.setAttribute('title', label);
      var text = control.querySelector('[data-rb-motion-label]');
      if (text) text.textContent = label;
    });
  });
})();
